<div class="thermo-wrapper" [style.max-height.px]="height">
  <svg viewBox="0 0 100 260" class="thermo" [style.max-height.px]="height">
    <rect x="35" y="30" width="30" height="170" rx="10" class="glass" />
    <g class="ticks">
      <ng-container *ngFor="let t of ticks.slice(2, ticks.length - 1); let i = index">
        <line
          x1="73"
          [attr.x2]="i % 2 === 0 ? 88 : 79"
          [attr.y1]="t"
          [attr.y2]="t"
        />
      </ng-container>
    </g>
    <rect
      x="42"
      [attr.y]="fluidY"
      width="17"
      [attr.height]="fluidHeight"
      [attr.fill]="fluidColor"
      class="fluid"
    />
    <circle cx="50" cy="210" r="35" [attr.fill]="fluidColor" />
    <text
      x="54"
      y="210"
      text-anchor="middle"
      dominant-baseline="middle"
      class="value-text"
    >
      {{ value }}°
    </text>
  </svg>
</div>
